import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { CoreModule } from '@core/core.module';
import { PipesModule } from '@core/pipes/pipes.module';

import { IconComponent } from '@shared/icon/icon.component';
import { RatingComponent } from '@shared/rating/rating.component';
import { DateFnsModule } from 'lingo2-ngx-date-fns';
import { OnUiButtonModule } from 'onclass-ui';
import { MeetingCardHalfComponent } from './meeting-card-half.component';

@NgModule({
  declarations: [MeetingCardHalfComponent],
  exports: [MeetingCardHalfComponent],
  imports: [
    LocaleSharedModule,
    CommonModule,
    RouterModule,
    CoreModule,

    PipesModule,
    DateFnsModule,
    OnUiButtonModule,
    RatingComponent,
    IconComponent,
  ],
})
export class MeetingCardHalfModule {}
